/**
 * Standalone Linked Accounts dialog opened from the main sidebar.
 * Wraps ConnectedAccountsPane in a modal — kept outside the Settings dialog
 * because the linked accounts are per-user, not per-workspace.
 */

import {
  Dialog,
  DialogContent,
  DialogTitle,
} from "@/components/ui/dialog";
import { ConnectedAccountsPane } from "./connected-accounts-pane";

interface LinkedAccountsDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function LinkedAccountsDialog({ open, onOpenChange }: LinkedAccountsDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="p-0 overflow-hidden sm:max-w-[620px] md:max-w-[680px]">
        <DialogTitle className="sr-only">Linked Accounts</DialogTitle>
        <div className="max-h-[80vh] overflow-y-auto">
          <ConnectedAccountsPane />
        </div>
      </DialogContent>
    </Dialog>
  );
}
